import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.31937 2.70312H2.61828C1.99851 2.70312 1.49609 3.20555 1.49609 3.82531V11.2275C1.49609 11.8473 1.99852 12.3497 2.61828 12.3497H10.0205C10.6402 12.3497 11.1426 11.8473 11.1426 11.2275V7.5264",
		stroke: "#0C90FF",
		strokeWidth: 1.36469,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.779 1.07061C8.69615 1.15446 8.64025 1.26107 8.61812 1.37669C8.59595 1.49237 8.60912 1.61247 8.65492 1.72083C8.70072 1.82919 8.7781 1.92188 8.87656 1.98653C8.97508 2.05112 9.0904 2.08499 9.20846 2.0843L11.143 2.08519L6.29091 6.9373C6.18275 7.04944 6.12371 7.19997 6.12526 7.35557C6.12725 7.51172 6.18956 7.66027 6.29996 7.77066C6.40986 7.88056 6.55889 7.94337 6.71455 7.94486C6.87065 7.9469 7.02069 7.88738 7.13332 7.77972L11.983 2.93009L11.9853 4.86117C11.979 4.94308 11.99 5.02563 12.0169 5.10315C12.0438 5.18064 12.0863 5.25155 12.1422 5.31196C12.1982 5.37238 12.2657 5.42028 12.341 5.4533C12.4159 5.48582 12.4973 5.50293 12.5796 5.50318C12.6615 5.50288 12.7429 5.48612 12.8183 5.4534C12.8933 5.42022 12.9611 5.37233 13.0166 5.31181C13.0727 5.25178 13.1152 5.18043 13.1421 5.10279C13.1695 5.02567 13.1802 4.94337 13.1737 4.86136L13.1735 1.49087C13.1729 1.33333 13.1106 1.18285 12.9992 1.07145C12.8878 0.960058 12.7368 0.897202 12.5792 0.8966L9.20825 0.895956C9.12874 0.894916 9.04946 0.90953 8.97571 0.939517C8.90197 0.969509 8.83529 1.01432 8.779 1.07061Z",
		fill: "#0C90FF",
		stroke: "#0C90FF",
		strokeWidth: .272937
	})]
});
export default SvgLink;
